import React from "react";
import { LoginLayout } from "../components";
import { ForgotPasswordForm } from "../features/auth";

const ForgotPasswordPage = () => (
  <LoginLayout>
    <ForgotPasswordForm />
  </LoginLayout>
);

export default ForgotPasswordPage;
